import React from "react";
import { APPOINTMENT_STATUS } from "./constants";

const AppointmentStatusBadge = ({ status, isPast, style }) => {
  return (
    <>
      {status === APPOINTMENT_STATUS.COMPLETE && (
        <span className="appt-status-badge appt-status-completed" style={style}>
          ✓ เสร็จสิ้น
        </span>
      )}
      {status === APPOINTMENT_STATUS.CANCEL && (
        <span className="appt-status-badge appt-status-cancelled" style={style}>
          ✕ ยกเลิก
        </span>
      )}
      {isPast && (status === APPOINTMENT_STATUS.WAITING || !status) && (
        <span className="appt-past-badge" style={style}>
          (ผ่านมาแล้ว)
        </span>
      )}
    </>
  );
};

export default AppointmentStatusBadge;
